import { StyleSheet, Text, TouchableHighlight, View } from '../base_components';
import React from 'react';

const styles = StyleSheet.create({
  textButton: {
    flexDirection: 'row',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#0044ee',
    borderRadius: '0.5em',
  },
  text: {
    paddingLeft: '1em',
    paddingRight: '1em',
    color: 'white',
    fontSize: '1.2em',
  },
});

type Props = {
  style?: any;
  textStyle?: any;
  text: string;
  underlayColor?: string;
  onPress: () => void;
};

export default class TextButton extends React.PureComponent<Props> {
  render() {
    const { style, textStyle, text, underlayColor, onPress } = this.props;

    return (
      <View style={[styles.textButton, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor={underlayColor || 'rgba(255,255,255,0.2)'}
          onPress={onPress}
        >
          <Text style={[styles.text, textStyle]}>{text}</Text>
        </TouchableHighlight>
      </View>
    );
  }
}
